import DebitIcon from "../assets/Debiticon.svg"
import CreditIcon from "../assets/CreditIcon.svg"
import Moment from "react-moment"
import WithdrawalModal from "./WithdrawalModal";
import PaymentModal from "./PaymentModal";
import { useState } from "react";
import { useParams } from 'react-router-dom';

function Transactions(props) {
    const { token } = useParams();
    const [withdrawModalShow, setWithdrawModalShow] = useState(false);
    const [ptData , setptData] = useState([]);
    const [wtData , setwtData] = useState([]);
    const [paymentModalShow, setPaymentModalShow] = useState(false);
    const showTrans = props.showTrans;


    const handleOpenWithraws = (e) => { 
      setWithdrawModalShow(true)
      const targetId = e.target.id
      showTrans.map(eachTrans => {
        const currentTransId = eachTrans.id
        const refId = eachTrans.tx_ref
       const getParticularTrans = async (refId, token) => {
        const getOptions = {
          method: 'GET',
          headers: {
            "Content-Type" : "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
           }
        };
        await fetch(`${process.env.REACT_APP_API_URL}/dashboard/particular-transaction/${refId}?type=Debit`, getOptions)
        .then(response => response.json())
        .then(data => {
            if(targetId === currentTransId){
                const wt_Data = data.transaction;
                setwtData(wt_Data)
                return data
            }
        })
        .catch(err => console.log(err))
       }
    
       getParticularTrans(refId , token)
       return eachTrans
      });
    }
    
    const handleOpenPayments = (e) => { 
      setPaymentModalShow(true)
      const targetId = e.target.id
      showTrans.map((eachTrans) => {
        const currentTransId = eachTrans.id
        const refId = eachTrans.tx_ref
       const getParticularTrans = async (refId, token) => {
        const getOptions = {
          method: 'GET',
          headers: {
            "Content-Type" : "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
           }
        };
        await fetch(`${process.env.REACT_APP_API_URL}/dashboard/particular-transaction/${refId}?type=Credit`, getOptions)
        .then(response => response.json())
        .then(data => {
            if(targetId === currentTransId){
                const pt_Data = data.transaction;
                setptData(pt_Data)
                return data
            }
        })
        .catch(err => console.log(err))
       }
    
       getParticularTrans(refId , token)
       return eachTrans
      });
    }
    
   
  return (
      <>
    <div className="daily-trans-group db-daily-trans-group">

      
        {showTrans.map(eachTrans => eachTrans.transaction_type === 'Credit' ?
          <div id={eachTrans.id}  key={eachTrans.id} className="trans-card" onClick={handleOpenPayments}>
              <div className="tc-left">
              <img className="credit-icon" src={CreditIcon} alt="credit" />
              <div className="name-time">
                  <p>{eachTrans.name.toUpperCase()}</p>
                  <Moment className="trans-time " format="Do MMMM, YYYY   h:mmA">{eachTrans.createdAt}</Moment>
              </div>
              </div>
              <p className="trans-amt text-success">₦{eachTrans.amount} </p>
          </div> :

          <div id={eachTrans.id}  key={eachTrans.id} className="trans-card" onClick={handleOpenWithraws}>
              <div className="tc-left">
              <img  className="debit-icon" src={DebitIcon} alt="debit" />
              <div className="name-time">
                  <p>{eachTrans.name}</p>
                  <Moment className="trans-time" format="Do MMMM, YYYY   h:mmA">{eachTrans.createdAt}</Moment>
              </div>
              </div>
              <p className="trans-amt text-danger"> ₦{eachTrans.amount} </p>
          </div>
        )}
          

      </div>

      <WithdrawalModal wtdata={wtData}  show={withdrawModalShow}
        onHide={() => setWithdrawModalShow(false)} />
        <PaymentModal ptdata={ptData} show={paymentModalShow} onHide={() => setPaymentModalShow(false)} />
      </>
  )
}

export default Transactions